<template>
    <!--销售下拉接口-->
    <el-select :value="id"  :placeholder="placeholder" :multiple="multiple" filterable :clearable="clearable" :size="size"
               @visible-change="visiblechange" @change="change">
        <el-option
                v-for="item in list"
                :key="item.id"
                :label="item.userName"
                :value="item.id">
        </el-option>
    </el-select>

</template>

<script>
    export default {
        name: "saler-list",
        props: {
            size: String,
            placeholder: String,
            required: Boolean,
            clearable: Boolean,
            multiple:Boolean,
            value: String|Array,
        },
        model: {
            prop: 'value',
            event: 'input'
        },
        data() {
            return {
                list: [],
                id: ''
            }
        },
        watch: {
            value(newval, oldval) {
                this.id = newval;
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.$axios.post('/user/userList', {
                    "storeId": this.$root.getStorage('storeId')
                }).then(res => {
                    console.log(res)
                    this.list = res.data.list;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            visiblechange(isshow) {
                if (isshow) {
                    this.getData();
                }
            },
            change(value) {
                // this.$emit('change', value);
                console.log(value)
                // this.roleId=value;
                // for(var i in this.list){
                //     if(this.list[i].roleId==value){
                //         this.$emit('getName', this.list[i].roleName);
                //     }
                // }
                this.$emit('input', value)
            }
        }
    }
</script>

<style scoped>

</style>